import { Controller } from 'stimulus';

/**
 * There was the problem that journey buttons "Bekijk accommodatie" were not
 * changed to "Toegevoegd aan reis" when the journey was added to the cart and the
 * user went back to the previous page.
 *
 * In that case the browser uses BFCache to cache the previous page, and thus
 * the state on the page was not updated. This controller listens to the BFCache
 * event and refreshes the actions on the page.
 */
class ActiveJourneyBlock extends Controller {
  connect() {
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        this.refreshActions();
      }
    });
  }

  async refreshActions() {
    // Retrieve cart items
    const data = await this.fetchActiveJourneyBlocks();

    // Extract journey ids from the cart items
    const journeyIds = data.items.map((item) => item.journey_id);

    // Refresh the actions on the page
    this.actionsTargets.forEach((target) => {
      const journeyId = parseInt(target.dataset.journeyId, 10);

      if (journeyIds.includes(journeyId)) {
        this.setActionToActive(target);
      }
    });
  }

  /**
   * Fetch the journey blocks in the cart
   *
   * @returns Promise<{ id: string, items: { id: string, block_id: number, journey_id: number }[] }>
   */
  async fetchActiveJourneyBlocks() {
    return fetch('/api/journey-cart-item')
      .then((response) => response.json());
  }

  setActionToActive(target) {
    target.querySelector('.js-selected-action').style.display = 'block';
    target.querySelector('.js-deselected-action').style.display = 'none';
  }
}

ActiveJourneyBlock.targets = [
  'actions',
];

export default ActiveJourneyBlock;
